/**
 * Applications module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

// Applications pages
const ApplicationsDashboardPage = lazyWithRetry(() => import('@/features/applications/pages/ApplicationsDashboardPage'));
const ApplicationsListPage = lazyWithRetry(() => import('@/features/applications/pages/ApplicationsListPage'));
const ApplicationDetailsPage = lazyWithRetry(() => import('@/features/applications/pages/ApplicationDetailsPage'));
const ApplicationCreatePage = lazyWithRetry(() => import('@/features/applications/pages/ApplicationCreatePage'));
const ApplicationEditPage = lazyWithRetry(() => import('@/features/applications/pages/ApplicationEditPage'));
const ApplicationVersionPage = lazyWithRetry(() => import('@/features/applications/pages/ApplicationVersionPage'));
// Inspection redesign, Phase 2: ROUTES.applications.mechanicInspection renders the new
// three-mode flow; the retired MechanicInspectionPage was deleted in f4839b68.
// Phase 4: the legacy per-item/bulk `InspectionPage.tsx` (routes `inspection`/`works`) was
// deleted with it — this is now the one inspection surface, for mechanics, dispatchers and ФМО.
const InspectionFlowPage = lazyWithRetry(() => import('@/features/applications/inspection-flow/pages/InspectionFlowPage'));
const AddExpensePage = lazyWithRetry(() => import('@/features/applications/pages/AddExpensePage'));

export const applicationsRoutes: RouteObject[] = [
      // --------------------------------
      // Applications Module
      // --------------------------------
      {
        path: '/applications/dashboard',
        element: (
          <PermissionRoute permission={PK.Applications.View}>
            <ApplicationsDashboardPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.applications.list,
        element: (
          <PermissionRoute permission={PK.Applications.View}>
            <ApplicationsListPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.applications.create,
        element: (
          <PermissionRoute permission={PK.Applications.Create}>
            <ApplicationCreatePage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.applications.details,
        element: (
          <PermissionRoute permission={PK.Applications.View}>
            <ApplicationDetailsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.applications.edit,
        element: (
          <PermissionRoute permission={PK.Applications.Edit}>
            <ApplicationEditPage />
          </PermissionRoute>
        ),
      },
      {
        // The view key, not the restore one: the page is worth opening without the right to roll
        // back, and its «Откатить» button checks `applications.versions.restore` by itself.
        path: ROUTES.applications.version,
        element: (
          <PermissionRoute permission={PK.Applications.VersionsView}>
            <ApplicationVersionPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.applications.mechanicInspection,
        element: (
          <PermissionRoute permission={PK.Applications.View}>
            <InspectionFlowPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.applications.addExpense,
        element: (
          <PermissionRoute permission={PK.Applications.ExpensesAdd}>
            <AddExpensePage />
          </PermissionRoute>
        ),
      },
];
